import config from 'helpers/imageSizes';
import { CONTENT_API_URL } from '../application/adapters/cms/constants';

interface ImageProps extends Umbraco.Image {
	width: number;
	height?: number;
	format?: 'webp';
}

export const GetImageUrl = ({ url, focalPoint, width, height = 0, format }: ImageProps): string => {
	if (!url) return '';

	const contentApiUrl = CONTENT_API_URL;
	let imageUrl = `${url}?width=${width}`;

	if (height > 0 && focalPoint)
		imageUrl = `${imageUrl}&height=${height}&mode=crop&center=${focalPoint.top.toString().replace(',', '.')},${focalPoint.left
			.toString()
			.replace(',', '.')}`;

	if (format) imageUrl = `${imageUrl}&format=webp`;

	if (!imageUrl.includes('http')) {
		imageUrl = contentApiUrl + imageUrl;
	}
	return imageUrl;
};

export const GetSrcSetString = ({
	url,
	focalPoint,
	format,
	aspectRatio,
}: {
	url: string;
	focalPoint: { top: number; left: number };
	format?: 'webp';
	aspectRatio?: number;
}): string => {
	const { imageSizes } = config.images;

	let string = '';

	imageSizes.map((width) => {
		let height = 0;

		if (aspectRatio) {
			height = aspectRatio * width;
		}

		return (string += `${GetImageUrl({
			url,
			focalPoint,
			height,
			width: width,
			format,
		})} ${width}w, `);
	});

	return string.substring(0, string.length - 2);
};
